<template functional>
        <li>
          <router-link
            v-if="!props.outside"
            class="nav-item"
            :to="props.link"
          >
            {{ props.label }}
          </router-link>
          <a v-else :href="props.link" :target="props.target" class="nav-item">
            {{ props.label }}
          </a>
        </li>
</template>

<script>

export default {
    props: {
        label: String,
        link: String,
        outside: Boolean,
        targte: String
    },
}
</script>

<style scoped>
.Footer {
  margin-top: 100px;
  background-color: #f8f8f8;
}
.Footer > .container {
  width: 45%;
  margin: 0 auto;
}
.Footer > .container > .nav {
  list-style: none;
  padding: 0;
  margin: 0;
}
.Footer > .container > .nav .nav-item {
  display: block;
  text-decoration: none;
  padding: 15px 10px;
  border-top: 2px solid transparent;
  font-size: 14px;
  font-weight: 300px;
  transition: 0.5s;
}
.Footer > .container > .nav .nav-item:hover {
  color: #0e7cd7;
  border-top: 2px solid #0e7cd7;
}
@media (max-width: 1024px) {
  .Footer > .container {
    width: 50%;
  }
}
@media (max-width: 768px) {
  .Footer > .container {
    width: 80%;
  }
  .Footer > .container > .nav {
    justify-content: space-around;
  }
}
@media (max-width: 425px) {
  .Footer {
    margin-top: 70px;
  }
  .Footer > .container {
    width: 90%;
  }
}
</style>